'use client'

import { createCustomer } from '@/lib/actions'
import { useModals, useSelectedCustomer } from '@/lib/hooks'
import type React from 'react'
import { useFormStatus } from 'react-dom'
import { toast } from 'sonner'

import { Badge, Button, Input, Label } from '@/components/ui'

export const CreateCustomer = () => {
  const { closeModal } = useModals()
  const { setCustomer } = useSelectedCustomer()

  const handleSubmit = async (formData: FormData) => {
    const data = {
      name: formData.get('name'),
      phone: formData.get('phone'),
      email: formData.get('email'),
    }

    if (!data.name || !data.phone) {
      return toast.error('Please fill required fields')
    }

    const customer = (await createCustomer(data)) as Customer | any

    if ('errors' in customer) {
      return toast.error(
        customer?.errors?.[0]?.errors?.[0] ?? 'Failed to create customer',
      )
    }

    // Set the newly created customer as selected
    await setCustomer(customer)

    toast.success('Customer created successfully')
    closeModal('CREATE_CUSTOMER')
  }

  return (
    <div className="flex h-full w-full">
      <form className="flex w-full flex-col gap-3" action={handleSubmit}>
        <div className="flex flex-col gap-1">
          <Label
            htmlFor="phone"
            className="flex items-center justify-between gap-1 !text-sm font-medium"
          >
            Name <Badge variant="outline">Required</Badge>
          </Label>
          <Input autoFocus name="name" placeholder="Enter customer name" />
        </div>

        <div className="flex flex-col gap-1">
          <Label
            htmlFor="phone"
            className="flex items-center justify-between gap-1 !text-sm font-medium"
          >
            Phone Number <Badge variant="outline">Required</Badge>
          </Label>
          <Input name="phone" placeholder="eg. 0777123456" />
        </div>

        <div className="flex flex-col gap-1">
          <Label htmlFor="email" className="!text-sm font-medium">
            Email Address
          </Label>
          <Input name="email" placeholder="Enter email address" />
        </div>

        <div className="flex w-full items-center pt-3">
          <SubmitButton />
        </div>
      </form>
    </div>
  )
}

const SubmitButton = () => {
  const { pending } = useFormStatus()

  return (
    <Button type="submit" className="w-full" disabled={pending}>
      {pending ? 'Creating...' : 'Create Customer'}
    </Button>
  )
}
